import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick(value) {
    submit({ type: 'add-subscribers' })
  }
}

export function isValid(stages, employees) {
  return !(stages.length > 0 && employees.length > 0)
}
